import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { loadUiSettings } from "./utils/uiSettings";

export const supportedLanguages = [
  { code: "en", label: "English" },
  { code: "zh-TW", label: "繁體中文（台灣）" },
];

export const resources = {
  en: {
    translation: {
      nav: {
        dataAcquisition: "Data Acquisition",
        dataProcessing: "Data Processing",
        preLabel: "Pre-Label",
        labelOperations: "Label Operations",
        datasetSplit: "Dataset Split",
        export: "Export",
        annotation: "Annotation",
        etl: "ETL",
        train: "Train",
        nef: "NEF",
        dashboard: "Dashboard",
        organizations: "Organizations",
        organization: "Organization: {{organization}}",
        systemSettings: "System Settings",
        logOut: "Log Out",
        signIn: "Please Signin",
        openNavigation: "Open navigation",
        closeNavigation: "Close navigation",
        openTool: "Open {{tool}}",
      },
      settings: {
        workspace: "Workspace",
        title: "System Settings",
        subtitle: "Manage this browser's workspace preferences.",
        saved: "Saved",
        appearanceTitle: "Appearance and data",
        browserPreference: "Preferences apply to this browser.",
        language: "Display language",
        languageDescription: "Choose the language used by the application interface.",
        density: "Workspace density",
        densityDescription: "Adjust spacing in navigation and workspace panels.",
        comfortable: "Comfortable",
        compact: "Compact",
        datasetsPerPage: "Datasets per page",
        datasetsPerPageDescription: "Set the default dataset gallery page size.",
        integratedTools: "Integrated tool shortcuts",
        integratedToolsDescription: "Show FiftyOne, CVAT, and Label Studio in the navigation bar.",
        datasetGroups: "Dataset groups",
        datasetGroupsDescription: "Show group filters in dataset workspace sidebars.",
        animations: "Interface animations",
        animationsDescription: "Enable transitions and animated feedback.",
        resetDefaults: "Reset defaults",
        savePreferences: "Save preferences",
        infrastructure: "Infrastructure",
        infrastructureDescription: "Administrator-only service and runtime configuration.",
        loadingConfiguration: "Loading configuration...",
        requestFailed: "Request failed",
        working: "Working...",
        general: "General",
        publicServer: "Public server",
        publicServerDescription: "Use public-service runtime behavior.",
        businessClient: "Business client",
        modelStoragePvc: "Model storage PVC",
        rsyncHost: "Public pre-label rsync host",
        saveGeneral: "Save general settings",
        generalSaved: "General settings saved.",
        kubeflowAvailable: "Kubeflow connection is available.",
        kubeflowSaved: "Kubeflow connection saved.",
        checkConnection: "Check connection",
        saveKubeflow: "Save Kubeflow",
        labelStudioAvailable: "Label Studio connection is available.",
        labelStudioSaved: "Label Studio connection saved.",
        apiKey: "API key",
        configuredApiKey: "Configured - enter a new key to replace",
        enterApiKey: "Enter API key",
        saveLabelStudio: "Save Label Studio",
        selectOption: "Select an option",
      },
    },
  },
  "zh-TW": {
    translation: {
      nav: {
        dataAcquisition: "資料擷取",
        dataProcessing: "資料處理",
        preLabel: "預先標註",
        labelOperations: "標註作業",
        datasetSplit: "資料集分割",
        export: "匯出",
        annotation: "標註",
        etl: "ETL",
        train: "訓練",
        nef: "NEF",
        dashboard: "儀表板",
        organizations: "組織管理",
        organization: "組織：{{organization}}",
        systemSettings: "系統設定",
        logOut: "登出",
        signIn: "請登入",
        openNavigation: "開啟導覽列",
        closeNavigation: "關閉導覽列",
        openTool: "開啟 {{tool}}",
      },
      settings: {
        workspace: "工作區",
        title: "系統設定",
        subtitle: "管理此瀏覽器的工作區偏好設定。",
        saved: "已儲存",
        appearanceTitle: "外觀與資料",
        browserPreference: "偏好設定僅套用於此瀏覽器。",
        language: "顯示語言",
        languageDescription: "選擇應用程式介面使用的語言。",
        density: "工作區密度",
        densityDescription: "調整導覽列與工作區面板的間距。",
        comfortable: "舒適",
        compact: "緊湊",
        datasetsPerPage: "每頁資料集數量",
        datasetsPerPageDescription: "設定資料集圖庫的預設每頁顯示數量。",
        integratedTools: "整合工具捷徑",
        integratedToolsDescription: "在導覽列顯示 FiftyOne、CVAT 與 Label Studio。",
        datasetGroups: "資料集群組",
        datasetGroupsDescription: "在資料集工作區側邊欄顯示群組篩選器。",
        animations: "介面動畫",
        animationsDescription: "啟用轉場與動畫回饋。",
        resetDefaults: "重設為預設值",
        savePreferences: "儲存偏好設定",
        infrastructure: "基礎架構",
        infrastructureDescription: "僅限管理員使用的服務與執行環境設定。",
        loadingConfiguration: "正在載入設定...",
        requestFailed: "要求失敗",
        working: "處理中...",
        general: "一般",
        publicServer: "公開伺服器",
        publicServerDescription: "使用公開服務的執行環境行為。",
        businessClient: "業務客戶端",
        modelStoragePvc: "模型儲存 PVC",
        rsyncHost: "公開預先標註 rsync 主機",
        saveGeneral: "儲存一般設定",
        generalSaved: "一般設定已儲存。",
        kubeflowAvailable: "Kubeflow 連線可用。",
        kubeflowSaved: "Kubeflow 連線已儲存。",
        checkConnection: "檢查連線",
        saveKubeflow: "儲存 Kubeflow",
        labelStudioAvailable: "Label Studio 連線可用。",
        labelStudioSaved: "Label Studio 連線已儲存。",
        apiKey: "API 金鑰",
        configuredApiKey: "已設定，輸入新金鑰即可取代",
        enterApiKey: "輸入 API 金鑰",
        saveLabelStudio: "儲存 Label Studio",
        selectOption: "選擇選項",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: loadUiSettings().language,
  fallbackLng: "en",
  supportedLngs: supportedLanguages.map(({ code }) => code),
  initImmediate: false,
  interpolation: { escapeValue: false },
});

export default i18n;
